// routes
import { PATH_DASHBOARD } from "../../../routes/paths";

const icon = (name) => (
  <img alt={name} src={`/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  coupon: icon("ic_coupon"),
  notification: icon("ic_notification"),
  profile: icon("ic_profile"),
  videohub: icon("ic_pages"),
  blogs: icon("ic_blogs"),
  settings: icon("ic_settings"),
  tripHour: icon("ic_trip_hr"),
  vehicle: icon("ic_vehicle"),
  reports: icon("ic_reports"),
  contacts: icon("ic_contacts"),
  stadium: icon("ic_stadium"),
  testimonials: icon("ic_testimonials"),
  season: icon("ic_season"),
  team: icon("ic_team"),
  position: icon("ic_position"),
  keyperson: icon("ic_keyperson"),
  role: icon("ic_role"),
  photo: icon("ic_photo"),
};

const navConfig = [
  {
    subheader: "NKL FIXTURES",
    items: [
      {
        title: "Matches",
        path: PATH_DASHBOARD.games.root,
        icon: ICONS.blogs,
        children: [{ title: "Matches list", path: PATH_DASHBOARD.games.list }],
      },
    ],
  },
];

export default navConfig;
